import { Component, Input, OnInit } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
    selector: 'app-module-error',
    templateUrl: './module-error.component.html',
    styleUrls: ['./module-error.component.scss']
})
export class ModuleErrorComponent implements OnInit {
    @Input() noData?: boolean;
    @Input() tooMuchData?: boolean;
    @Input() noMetric?: boolean;
    @Input() dateRangeTooWideIntraday?: boolean;
    @Input() noAgentsSelected?: boolean;
    @Input() intervalRangeTooWide?: boolean;
    @Input() noPMLicense?: boolean;


    constructor(public configService: CvConfigurationService) { }

    ngOnInit(): void {

    }
}
